const Conditional = props => {
  return !!props.if && (props.children || null);
};

export default Conditional;
